import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const ZOOM_FOR_ICON_CHANGE = 9;
const ZOOM_FOR_ICON_SHOW = 6;

const PaymentPoints = React.memo(({ points, zoom }) => {
    if (zoom <= ZOOM_FOR_ICON_SHOW) {
        return null;
    }
    const iconProps =
        zoom > ZOOM_FOR_ICON_CHANGE
            ? { className: "map-icon--payment-points", iconSize: [22, 22] }
            : { className: "map-icon--payment-dot", iconSize: [8, 8] };
    const icon = divIcon(iconProps);
    return points.map((el, index) => <PaymentPoint key={index} icon={icon} item={el} />);
});

const PaymentPoint = (props) => {
    const {
        item: { location, highway, tollBooth },
        icon,
    } = props;
    if (!location?.coordinates) {
        return null;
    }
    return (
        <Marker position={[...location.coordinates].reverse()} icon={icon}>
            <Tooltip direction="top">
                <div className="font-weight-bold">{tollBooth}</div>
                <div>Трасса: {highway}</div>
            </Tooltip>
        </Marker>
    );
};

const MemoizedPaymentPoints = (props) => <PaymentPoints {...props} />;

export default MemoizedPaymentPoints;
